import {
  ACTION_LOAD_PAYOUT_REQUEST_DETAILS__REQUEST,
  ACTION_LOAD_PAYOUT_REQUEST_DETAILS__SUCCESS,
  ACTION_LOAD_PAYOUT_REQUEST_DETAILS__FAIL,
} from '../../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_PAYOUT_REQUEST_DETAILS__REQUEST:
    case ACTION_LOAD_PAYOUT_REQUEST_DETAILS__SUCCESS:
      return null;

    case ACTION_LOAD_PAYOUT_REQUEST_DETAILS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
